import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MainLogo from "../../assets/images/mainlogoNew.png";
import { ReactComponent as HamburgerIcon } from "../../assets/svg/hamburger-menu-icon.svg";

/**
 * The header of a dashboard page.
 *
 * It used to be a navigation bar — logo, search, bell, avatar — but all of
 * that moved to the sidebar, leaving a single 32px title floating over an
 * empty rule. A title that size, alone, reads as a banner rather than as the
 * name of the page, and every page was already passing a subtitle that
 * nothing rendered.
 *
 * So this is now what it actually is: the page's name at a normal heading
 * size, one line saying what the page is for, and the action that belongs to
 * the page on the right.
 */
function Navbar({
  visible,
  headingTitle,
  headingSubtitle,
  headingAction,
  handleDrawerToggle,
  isWithoutSideBar,
}) {
  const { t } = useTranslation();

  if (!visible) {
    return null;
  }

  // PropertyView mounts this only for the logo and the mobile menu; without
  // a title there is no header to draw, just the rail.
  const hasHeading = Boolean(headingTitle || headingSubtitle || headingAction);

  return (
    <Box className={`ep-page-header${hasHeading ? "" : " is-bare"}`}>
      <Box className="ep-page-header-main">
        <IconButton
          className="ep-page-header-burger"
          onClick={handleDrawerToggle}
          aria-label={t("Common.Menu")}
        >
          <HamburgerIcon className="dashboard-nav-hamburger-icon" />
        </IconButton>

        {isWithoutSideBar && (
          <Box className="ep-page-header-logo">
            <Link to="/">
              <img src={MainLogo} alt="Easy Property" className="logo-img" />
            </Link>
          </Box>
        )}

        {hasHeading && (
          <Box sx={{ minWidth: 0 }}>
            {headingTitle && (
              <Typography component="h1" className="ep-page-header-title">
                {headingTitle}
              </Typography>
            )}
            {headingSubtitle && (
              <Typography component="p" className="ep-page-header-sub">
                {headingSubtitle}
              </Typography>
            )}
          </Box>
        )}
      </Box>

      {headingAction && (
        <Box className="ep-page-header-action">{headingAction}</Box>
      )}
    </Box>
  );
}

export default Navbar;

Navbar.defaultProps = {
  visible: true,
};
